import axios from 'axios';
import { getStepUpUUID, getCsrfToken } from '../../helpers/twHelper';

export const CONFIRM_YES = 'YES';
export const CONFIRM_NO = 'NO';
export const INIT_AUTH_CALL = 'INIT_AUTH_CALL';
export const CONFIRM_AUTH_CALL = 'CONFIRM_AUTH_CALL';
export const REJECT_AUTH_CALL = 'REJECT_AUTH_CALL';
export const CLOSE_AUTH_CALL = 'CLOSE_AUTH_CALL';
export const SENDING_CONFIRM = 'SENDING_CONFIRM';
export const AUTH_FAILED = 'AUTH_FAILED';

export const initAuthPrompt = (display) => ({
  type: INIT_AUTH_CALL,
  payload: display,
});

const confirmCall = () => ({ type: CONFIRM_AUTH_CALL });

const rejectConfirm = () => ({ type: REJECT_AUTH_CALL });

const sendingAuthPrompt = () => ({ type: SENDING_CONFIRM });

const authFailed = () => ({ type: AUTH_FAILED });

const sendConfirmation = (decision) => (dispatch) => {
  dispatch(sendingAuthPrompt());

  return axios
    .post('/smarthelp/validate-confirm-login', {
      _csrf: getCsrfToken(),
      decision,
      docId: getStepUpUUID(),
    })
    .then(() => {
      if (decision === CONFIRM_YES) {
        dispatch(confirmCall());
      } else if (decision === CONFIRM_NO) {
        dispatch(rejectConfirm());
      }
    })
    .catch(() => {
      dispatch(authFailed());
    });
};

// Users clicked 'Yes' button in the Auth prompt module
export const authConfirmWithYes = () => (dispatch) => {
  dispatch(sendConfirmation(CONFIRM_YES));
};

// Users clicked 'No' button in the Auth prompt module
export const authConfirmWithNo = () => (dispatch) => {
  dispatch(sendConfirmation(CONFIRM_NO));
};

export const closeWindow = () => ({ type: CLOSE_AUTH_CALL });
